export default __webpack_public_path__ + "static/media/default_calendar.31cbca32.svg";